<div class="container-fluid px-4 mt-4 mb-5" *ngIf="facilityId>0;else noId">
    <div class="row">
        <div class="col-xl-12">
            <ul ngbNav #nav="ngbNav" [(activeId)]="active" class="nav-tabs">
                <li [ngbNavItem]="1">
                    <a ngbNavLink>CONTROL DE INGRESO</a>
                    <ng-template ngbNavContent>
                        <app-list-controls-facility [facilityId]="facilityId"  />
                    </ng-template>
                </li>
                <li [ngbNavItem]="2">
                    <a ngbNavLink>CONTROL RONDAS</a>
                    <ng-template ngbNavContent>
                        <app-list-rounds-facility [facilityId]="facilityId" />
                    </ng-template>
                </li>
            </ul>
            <div [ngbNavOutlet]="nav" class="mt-2"></div>
        </div>
    </div>

</div>
<ng-template #noId>
    No se ha recibido el identificador de la instalación
</ng-template>